import { createSlice } from "@reduxjs/toolkit";

export type AlertState = {
    color: "primary" | "success" | "danger" | "warning" ;
    text: string;
    subText?: string
    isOpen:boolean;
  };

const initialState = {
  alert : {
    color: "primary",
    text: "",
    subText:"",
    isOpen: false
  }
};

const name = "auth";
const alertSlice = createSlice({
  name,
  initialState,
  reducers: {
    alertOpen: (state,action) => {
      state.alert.color = action.payload.color;
      state.alert.text = action.payload.text;
      state.alert.subText = action.payload.subText;
      state.alert.isOpen = true;
    },
    alertClose: (state) => {
      state.alert = { color: "primary", subText:"",text: "", isOpen: false };
    },
  },
});

export const AlertValue = (text:string,color: "primary" | "success" | "danger" | "warning" ,subText?:string) =>{
  const alert = {text:text,color:color,subText:subText};
  return alert;
}


export const { alertOpen, alertClose } = alertSlice.actions;
export const selectAlert = (state: any) => state.alert.alert;
export const selectIsOpne = (state: any) => state.alert.alert.isOpen;

export const alertReducer = alertSlice.reducer;

